import React, { useState } from "react";
import { Modal, Form, Input, Button, App } from "antd";
import {
  EyeOutlined,
  EyeInvisibleOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import http from "../../services/http";

const ChangePasswordModal = ({ visible, onClose }) => {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      if (values.newPassword !== values.confirmPassword) {
        message.error("New password and confirm password do not match");
        return;
      }

      setLoading(true);
      
      await http.post("/auth/change-password", {
        oldPassword: values.currentPassword,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
      });

      message.success("Password changed successfully");
      form.resetFields();
      onClose();
    } catch (error) {
      console.error("Error changing password:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={460}
      closeIcon={<CloseOutlined />}
      className="change-password-modal"
      centered
    >
      <h2 className="text-xl font-semibold text-gray-900 text-center mb-6">
        Change Password
      </h2>

      <Form form={form} layout="vertical">
        <Form.Item
          label={
            <span className="text-sm text-gray-700">
              Enter your Current Password
            </span>
          }
          name="currentPassword"
          rules={[{ required: true, message: "Please enter current password" }]}
        >
          <Input.Password
            placeholder="Enter your current password"
            iconRender={(visible) =>
              visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>

        <Form.Item
          label={
            <span className="text-sm text-gray-700">Create a New Password</span>
          }
          name="newPassword"
          rules={[
            { required: true, message: "Please enter new password" },
            { min: 8, message: "Password must be at least 8 characters" },
          ]}
        >
          <Input.Password
            placeholder="Create a new password"
            iconRender={(visible) =>
              visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>

        <Form.Item
          label={
            <span className="text-sm text-gray-700">
              Confirm your New Password
            </span>
          }
          name="confirmPassword"
          rules={[
            { required: true, message: "Please confirm your password" },
            { min: 8, message: "Password must be at least 8 characters" },
          ]}
        >
          <Input.Password
            placeholder="Confirm your new password"
            iconRender={(visible) =>
              visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>

        <Button
          type="primary"
          block
          size="large"
          onClick={handleSubmit}
          loading={loading}
          className="bg-purple-600 hover:bg-purple-700 border-0 mt-4"
        >
          Save Changes
        </Button>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
